export default __webpack_public_path__ + "static/9.Kiddie Explorers Preschool-eba2932c82708f453c4218e83f6070b3.png";